import { gql } from '@apollo/client'

export const FORCE_ADD_ATTENDEE = gql`
    mutation AttendEventWithoutAccount(
        $input: attendEventWithoutAccountInput!
    ) {
        attendEventWithoutAccount(input: $input) {
            entity {
                guid
                ... on Event {
                    attendees(
                        limit: 3
                        state: "accept"
                        orderBy: timeUpdated
                        orderDirection: desc
                    ) {
                        total
                        totalAccept
                        totalMaybe
                        totalOnline
                        totalReject
                        totalWaitinglist
                        edges {
                            guid
                            name
                            state
                            url
                            icon
                        }
                    }
                }
            }
        }
    }
`
